import React, { useEffect, useState, useCallback, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { Modal, Button, ProgressBar } from "react-bootstrap";
import "./uploadMyReport.css";
import { getReportsForMyChat } from "apiServices/reducer/apiService";
import { useDispatch, useSelector } from "react-redux";
import { saveReportDocumentChat } from "apiServices/reducer/apiService";
import { toast } from "react-toastify";

const UploadMyReports = ({ currentUser, onClose, onReportSelected, chatData }) => {
  const [lstReports, setLstReports] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [submitted, setSubmitted] = useState(false);
  const [progress, setProgress] = useState(0);
  const uploadInProgressRef = useRef(false);
  const gridApi = useRef(null);
  const dispatch = useDispatch();
  const [chatHistory, setChatHistory] = useState(chatData);
  const token = useSelector((state) => state.apiService.token);
  const userData = useSelector((state) => state.apiService.login);
  const params = {
    token: token,
    user_id: userData?.user_id
  };
  const getReportsForMyreports = async (userId) => {
    // Replace with your actual API call
    // return fetch(...).then(res => res.json());
    return {
      Table: [
        { report_id: 1, report_name: "Report 1", hospital_name: "Hospital A", created_on: "2024-06-01" },
        { report_id: 2, report_name: "Report 2", hospital_name: "Hospital B", created_on: "2024-06-02" },
      ],
    };
  };
  useEffect(() => {
    console.log("currentUser", chatHistory);
    dispatch(getReportsForMyChat(params)).then((res) => {
      console.log("Reports for my chat", res);
      const reports = res.payload;
      setLstReports(reports);
    });
  }, [currentUser]);

  const handleHeaderCheckboxChange = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    if (gridApi.current) {
      if (checked) {
        gridApi.current.selectAll();
        const allIds = lstReports.map(report => report.report_id);
        setSelectedRows(new Set(allIds));
      } else {
        gridApi.current.deselectAll();
        setSelectedRows(new Set());
      }
    }
  };

  const handleRowCheckboxChange = (report, checked) => {
    console.log(report, "report");
    setSelectedReport(report);
    const newSelectedRows = new Set(selectedRows);
    if (checked) {
      newSelectedRows.add(report.report_id);
    } else {
      newSelectedRows.delete(report.report_id);
    }
    setSelectedRows(newSelectedRows);
    setSelectAll(newSelectedRows.size === lstReports.length);
  };

  const columnDefs = [
    {
      headerName: "",
      field: "checkbox",
      headerCheckboxSelection: false,
      checkboxSelection: false,
      width: 50,
      minWidth: 50,
      maxWidth: 50,
      resizable: false,
      suppressMenu: true,
      pinned: 'left',
      headerComponent: () => (
        <input
          type="checkbox"
          className="input-upload-reports-modal"
          checked={selectAll}
          onChange={handleHeaderCheckboxChange}
          style={{ cursor: 'pointer' }}
        />
      ),
      cellRenderer: (params) => {
        const isChecked = selectedRows.has(params.data.report_id);
        return (
          <input
            type="checkbox"
            className="input-upload-reports-modal"
            checked={isChecked}
            onChange={(e) => {
              e.stopPropagation();
              handleRowCheckboxChange(params.data, e.target.checked);
            }}
            style={{ cursor: 'pointer' }}
          />
        );
      }
    },
    { headerName: "Report Name", field: "report_name", flex: 2, minWidth: 250, autoHeight: true, cellStyle: { whiteSpace: 'normal' }, tooltipField: "report_name", headerTooltip: "Report Name" },
    { headerName: "Hospital", field: "hospital_name", flex: 1, tooltipField: "hospital_name", headerTooltip: "Hospital Name" },
    { headerName: "Report Date", field: "created_on", flex: 1, tooltipField: "created_on", headerTooltip: "Report Date" },
  ];

  const onSelectionChanged = useCallback(() => {
    const selectedNodes = gridApi.current.getSelectedNodes();
    const selectedIds = new Set(selectedNodes.map(node => node.data.report_id));
    setSelectedRows(selectedIds);
    setSelectAll(selectedIds.size === lstReports.length);
    setSelectedReport(selectedNodes.length > 0 ? selectedNodes[0].data : null);
  }, [lstReports.length]);

  const onGridReady = (params) => {
    gridApi.current = params.api;
  };

  const showToast = (type, message) => {
    toast[type](message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  const uploadFilereport = async () => {
    if (uploadInProgressRef.current) return;
    console.log(chatData, "chatData");

    if (selectedRows.size === 0) {
      showToast('error', 'Please select at least one report to upload.');
      return;
    }

    uploadInProgressRef.current = true;
    //setSubmitted(true);

    try {

      //  for (const report of selectedReports) {
      const formData = new FormData();
      formData.append('reportId', selectedReport.report_id);
      formData.append('fileName', selectedReport.report_name);
      formData.append('token', token);
      formData.append('messageType', 4);
      formData.append('message', "");
      formData.append('senderId', userData?.user_id);
      formData.append('receiverId', chatHistory.length > 0 ? chatHistory[0].receiver_id == null ? 0 : chatHistory[0].receiver_id : 0);
      formData.append('chatId', chatHistory.length > 0 ? chatHistory[0].chat_id == null ? 0 : chatHistory[0].chat_id : 0);
      formData.append('loginUserId', userData?.user_id);
      console.log(formData, "formData");


      dispatch(saveReportDocumentChat(formData)).then((res) => {
        console.log(res, "response after upload");
        if (res.payload.status === 201) {
          showToast('success', `Report uploaded successfully`);
          onClose();
        } else {
          showToast('error', `Report "${selectedReport.report_name}" uploaded failed`);
        }
      });


    } catch (error) {

    }
  };

  return (
    <Modal
      show={true}
      onHide={onClose}
      size="lg"
      centered
      backdrop="static"
      dialogClassName="receipts-modal-size"
      keyboard={false}
    >
      <Modal.Header className="custom-modal-header">
        <Modal.Title className="text-capitalize fw-bold">Upload From My Report</Modal.Title>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onClose}
        ></button>
      </Modal.Header>

      <Modal.Body style={{ padding: "2rem 2.5rem" }}>
        <div
          className="ag-theme-balham"
          style={{ width: "100%", height: "400px" }}
        >
          <AgGridReact
            rowData={lstReports}
            columnDefs={columnDefs}
            enableBrowserTooltips={true}
            tooltipShowDelay={0}
            defaultColDef={{ sortable: true, filter: true, resizable: true }}
            rowSelection="single"
            onSelectionChanged={onSelectionChanged}
            onGridReady={onGridReady}
            statusBar={true}
          />
        </div>


      </Modal.Body>

      <Modal.Footer className="justify-content-center">
        <Button
          variant="primary"
          onClick={uploadFilereport}
          className="upload-btn-receipts me-2"
          disabled={uploadInProgressRef.current || selectedRows.size === 0}
        >
          Upload
        </Button>
        <Button
          variant="danger"
          onClick={onClose}
          className="upload-btn-receipts ms-2"
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UploadMyReports;

